import React from "react";
import { createDrawerNavigator } from "@react-navigation/drawer";
import OrderScreens from "./orders";
import Tabs from "./Tabs";
import Sidebar from "./Sidebar";
import { connect } from "react-redux";
import Launch from "./Launch";

const DrawerNavigator = createDrawerNavigator();

function SecuredScreens({ userOption }) {
  const SCREENS = [
    { name: "tabs", component: Tabs },
    { name: "orders", component: OrderScreens },
  ];

  return (
    <>
      {userOption.itemsFilter ? (
        <DrawerNavigator.Navigator
          initialRouteName={SCREENS[0].name}
          drawerContent={(props) => <Sidebar {...props} />}
        >
          {SCREENS.map(({ name, component }, index) => (
            <DrawerNavigator.Screen
              name={name}
              component={component}
              key={index + "d"}
            />
          ))}
        </DrawerNavigator.Navigator>
      ) : (
        <Launch />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  userOption: state.filter.userOption,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SecuredScreens);
